import { useState } from 'react';
import { Box, Button, Container, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';

import { styled } from '@mui/material/styles';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import SuspenseLoader from './SuspenseLoader';
import { ApiManager } from 'src/managers/ApiManager';
import { ApiException, ILoginModel, LoginModel } from 'src/api/ApiClient';
import IthSimpleDialog from './IthSimpleDialog';
import { ContextManager } from 'src/managers/ContextManager';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import IthLoadDialog from './IthLoadDialog';

const TypographyH2 = styled(Typography)(
  ({ theme }) => `
    font-size: ${theme.typography.pxToRem(20)};
`
);

const DIALOG_TITLE_ERROR : string = "Error";

const IthLoginForm = (props: {
    //setToken: React.Dispatch<React.SetStateAction<string>>
}) => {
  const navigate = useNavigate()

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => { event.preventDefault(); };
  
  const [username, setEmail] = useState<string>("")
  const [password, setPassword] = useState<string>("")

  const [openLoadDialog, setOpenLoadDialog] = useState(false);

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState<string>("")
  const [body, setBody] = useState<string>("")
  const handleClickOpen = (title, body) => { setOpen(true); setTitle(title); setBody(body); };
  const handleClose = () => { setOpen(false); };
  const apiClient = ApiManager.getApiClientInstance();

  const login = async (event) => {
    event.preventDefault()
    if (username && password) {
        const loginModel: ILoginModel = {
          username,
          password,
        }
      
        setOpenLoadDialog(true);

      apiClient.apiAuthenticationLogin(new LoginModel(loginModel))
        .then((data: any) => {
          ContextManager.prepareContext(username, data)
          .then(() => {
            navigate("/establishment")
          });
        })
        .catch((e: ApiException) => {
          console.log(e);
          handleClickOpen(DIALOG_TITLE_ERROR, e.response);
        })
        .finally(() =>{
          setOpenLoadDialog(false);
        });
    }
  };

  return (
    <Container maxWidth="xs" sx={{ textAlign: 'center' }}>
      <IthLoadDialog open={openLoadDialog} />
      <IthSimpleDialog
        open={open}
        title={title}
        body={body}
        onClose={handleClose}
      />
      <TypographyH2 sx={{ lineHeight: 1.5, pb: 0 }} variant="h4"color="text.secondary" fontWeight="normal">
        Accede a la aplicación
      </TypographyH2>
      <Box 
          component="form" 
          onSubmit={login} 
          noValidate 
          sx={{  
              marginTop: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
      >
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Correo electrónico"
          name="email"
          autoComplete="email"
          autoFocus
          onChange={(e) => setEmail(e.target.value)}
        />

        <FormControl 
          margin="normal"
          fullWidth
          required
          variant="outlined"
          >
          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormControl>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Entrar
        </Button>
        <Grid container>
          <Grid item>
            <Button
                disableRipple
                component={RouterLink}
                to="/register"
              >
                {"¿No tienes cuenta? Regístrate"}
              </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default IthLoginForm;
